const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const specialPattern = /[(!@#$%^&*)\d]/;
const minPasswordLength = 8;

function validateEmail(val) {
  return emailPattern.test(val) || 'Invalid e-mail';
}

function validatePasswordLength(val) {
  return (!!val && val.length >= minPasswordLength) || `Must be at least ${minPasswordLength} characters`;
}

function validateSpecialChars(val) {
  return specialPattern.test(val) || 'Must contain a digit or special character';
}

function validatePasswordMatch(val) {
  const newPasswordElement = document.getElementById('newPassword');
  return (newPasswordElement && newPasswordElement.value === val) || 'Passwords must match';
}

export default () => ({
  username: {
    name: 'Email',
    type: 'email',
    postName: 'username',
    modes: ['login', 'register', 'forgot'],
    value: '',
    rules: [validateEmail],
  },
  nickname: {
    name: 'Nickname',
    type: 'text',
    postName: 'nickname',
    modes: ['register'],
    value: '',
  },
  password: {
    name: 'Password',
    type: 'password',
    postName: 'password',
    modes: ['login', 'update'],
    showPassword: false,
    value: '',
  },
  newPassword: {
    name: 'New Password',
    type: 'password',
    postName: 'password',
    modes: ['register', 'update', 'reset'],
    showPassword: false,
    value: '',
    rules: [validatePasswordLength, validateSpecialChars],
    disableAutoComplete: true,
  },
  confirmPassword: {
    name: 'Confirm Password',
    type: 'password',
    modes: ['register', 'update', 'reset'],
    showPassword: false,
    value: '',
    rules: [validatePasswordMatch],
    disableAutoComplete: true,
  },
});
